import cx from "classnames";
//Language
import { useIntl } from "react-intl";

import { Chip } from "@mui/material";

//Styles
import "./menu.scss";

const VidFleetMenu = (props) => {
    const { messages } = useIntl();

    const options = [
        {
            id: 0,
            label: messages['vidfleet_events'],

        },
        {
            id: 1,
            label: messages['vidfleet_user'],

        },
        {
            id: 2,
            label: messages['vidfleet_warning'],

        },
        {
            id: 3,
            label: messages['vidfleet_camera_logs'],
        },
        {
            id: 4,
            label: messages['vidfleet_dms_statuses'],
        },
        {
            id: 5,
            label: messages['vidfleet_power_lost'],
        },
        {
            id: 6,
            label: messages['vidfleet_sd_card_status'],
        }
    ]

    return (
        <div className="vidfleet-menu">
            {
                options.map((option, index) => {
                    if (props?.module === option.id) {
                        return (
                            <Chip
                                className={cx("vidfleet-menu-general vidfleet-menu-pill-selected")}
                                color="primary"
                                label={option?.label || ''}
                                key={index}
                            />);
                    } else {
                        return (
                            <Chip
                                className={cx("vidfleet-menu-general vidfleet-menu-pill")}
                                onClick={() => {
                                    props?.setModule && props.setModule(option.id)
                                }}
                                label={option?.label || ''}
                                key={index}
                            />);
                    }
                })
            }
        </div>
    )
}
export default VidFleetMenu;